export const setInLocalStorage = (key, value) => {
  if (!key || !value) {
    throw new Error('Key and value are required');
  }
  localStorage.setItem(key, JSON.stringify(value));
};

export const getFromLocalStorage = (key: string, defaultValue?: undefined | string) => {
  const value = localStorage.getItem(key);

  if (value && typeof value !== 'string') {
    throw new Error('Value must be a string.');
  }

  return value ? JSON.parse(value) : defaultValue;
};
